/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';

import gsLogoWhite from '../assets/logos/general_de_seguros_logo.png';
import { EXIT_URL } from '../constants/constants';

const NavbarContainer = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const menuToggleHandle = (event) => {
    event.preventDefault();
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <div className="navbar">
      <div className="navbar-desktop">
        <a className="link-logo" href={EXIT_URL}>
          <img alt="Logo General de Seguros" src={gsLogoWhite} />
        </a>
      </div>
      <div className="navbar-mobile">
        <a className="link-logo" href={EXIT_URL}>
          <img alt="Logo General de Seguros" src={gsLogoWhite} />
        </a>
        <div className={`menu-mobile ${isMobileOpen ? '-visible' : ''}`}>
          <div className="menu-overlay" onClick={menuToggleHandle} />
          <div className="menu-nav">
            <button onClick={menuToggleHandle} type="button" className="btn -close">&times;</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarContainer;
